import React from 'react'
import { Table } from 'react-bootstrap';
import styles from "./Table.module.scss";
import { DownArrowTable } from '../../../assets/icons/svgicons';

const TableLoading = ({ fields, className }) => {
    return (
        <>
            <Table
                responsive
                className={`${styles.table} ${className || ""}`}
            >
                {fields && <thead>
                    <tr>
                        {
                            fields.map(item => (
                                <th key={item.label} className={item?.className}>
                                    {item.label}
                                    {item.sort && <button className={`${styles.sort} ${false ? styles.active : ""}`}>
                                        <DownArrowTable />
                                    </button>}
                                </th>
                            ))
                        }
                    </tr>
                </thead>}
                <tbody>
                    {
                        Array.from({ length: 4 }).map((item, index) => (
                            <tr key={index}>
                                {Array.from({ length: fields?.length || 2 }).map((td, index) => <td key={index}><span className={styles.loading} /></td>)}
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
        </>
    )
}

export default TableLoading
